class CartRelatedSuggestions extends HTMLElement {
  static get observedAttributes() {
    return ['data-url', 'data-cart-signature'];
  }

  connectedCallback() {
    this.loadSuggestions();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (
      oldValue !== null &&
      oldValue !== newValue &&
      this.isConnected
    ) {
      this.loadSuggestions();
    }
  }

  async loadSuggestions() {
    const url = this.dataset.url;

    if (!url) {
      this.hidden = true;
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: this.abortController.signal
      });

      if (!response.ok) {
        throw new Error(`Error al cargar recomendaciones: ${response.status}`);
      }

      const responseText = await response.text();

      const responseDocument = new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

      const recommendations = responseDocument.querySelector(
        '[data-related-products-content]'
      );

      const hasProducts =
        recommendations &&
        recommendations.querySelector(
          '.essentia-related-products__card'
        );

      if (!hasProducts) {
        this.replaceChildren();
        this.hidden = true;
        return;
      }

      this.replaceChildren(recommendations);
      this.hidden = false;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn(
          'No fue posible cargar las recomendaciones del carrito.',
          error
        );

        this.hidden = true;
      }
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('cart-related-suggestions')) {
  customElements.define(
    'cart-related-suggestions',
    CartRelatedSuggestions
  );
}